<template>
<div class="container">
  <div class="name">
    <div class="labeler">Name:</div>
    {{algo.name}}
  </div>
  <div class="pclass">
    <div  class="labeler">Type/Class:</div>
    {{algo.class}}</div>

  <div class="link" @click="routeTo(algo.id)">Details</div>
  <div class="link" @click="external(algo.link)">Reference</div>
</div>
</template>

<script>

export default {
  name: "AlgoRow",

  props: ["algo"],
  methods: {
    routeTo(path) {
      this.$router.push({name: "algo", params: {algoId: path}});
    },
    external(path) {
      window.open(path);
    }
  }

}
</script>

<style scoped>
.container {
  width: calc(100% - 6px);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  background: rgba(10, 10, 10, .02);
  margin-bottom: 15px;
  padding: 3px;
}
.name {
  width: 250px;
  flex-wrap: wrap;
  text-align: left;
  align-items: center;
  justify-content: left;
}
.pclass {
  width: 150px;

  text-align: left;
  align-items: center;
  justify-content: left;
}

.compl {
  width: 80px;
  text-align: left;
  align-items: center;
  justify-content: left;
}

.labeler {
  font-size: 12px;
  font-weight: bold;
  color: rgba(100, 149, 237, 0.6);
}
.link {
  color: white;
  font-size: 13px;
  font-weight: bolder;
  align-self: center;
  padding: 6px;
  background: rgba(100, 149, 237, 0.6);
  border-radius: 5px;
  cursor: pointer;

}
</style>